import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'

type Payload = {
  boardId: number
  name: string
  template: any
  position?: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { boardId, template, name } = payload

  try {
    await apiAction('AddCard', {
      template: template ? { type: 'card', id: template } : undefined,
      boardId,
      name: name.trim(),
      isTemplate: true
    })
  } catch (error) {
    if (error.code === 543) { // KanBo Exception: Board has no default status
      try {
        await sweetalert({
          text: getState().kanbo.locale.messages['CARD_ADD_NO_DEFAULT_STATUS'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
